<template>

  <v-col>
    <v-row
      justify="center"
      class="mb-5 mt-2"
    >
      <v-icon
        :color="color"
        :size="!small?58:25"
      >{{icon?icon:'mdi-help-circle'}}</v-icon>
    </v-row>
    <v-row justify="center">
      <span
        class="text-center headline font-weight-bold grey--text text--darken-1"
        :class="{'subtitle-2':small}"
      >
        {{message}} </span>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    icon: String,
    message: String,
    small: Boolean,
    color: String,
  }
};
</script>
